import { comparisonData } from '@/mocks/faq';

export default function ComparisonTable() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <div className="text-center mb-10">
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 font-medium mb-3">
            How We Compare
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            See why the allchinabuyspreadsheet is the best choice for finding trusted products and sellers.
          </p>
        </div>

        <div className="bg-white rounded-2xl border border-background-200/70 overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="border-b border-background-200/70">
                <th className="text-left px-6 py-4 text-sm font-semibold text-foreground-700">Feature</th>
                <th className="text-center px-6 py-4 text-sm font-semibold text-primary-600">
                  AllChinaBuySpreadsheet
                </th>
                <th className="text-center px-6 py-4 text-sm font-semibold text-foreground-500">
                  Random Spreadsheet
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row) => (
                <tr key={row.feature} className="border-b border-background-100 last:border-0">
                  <td className="px-6 py-4 text-sm text-foreground-700 font-medium">{row.feature}</td>
                  <td className="px-6 py-4 text-center">
                    <span className={`inline-flex items-center gap-1 text-sm font-semibold ${row.allchina === 'Yes' || row.allchina === '14+' ? 'text-primary-600' : 'text-foreground-600'}`}>
                      {row.allchina === 'Yes' && (
                        <div className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-check-line text-base"></i>
                        </div>
                      )}
                      {row.allchina}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-center">
                    <span className="text-sm text-foreground-400">{row.random}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}